export default class AutoplayOptions {
    public autoplays: number;
    public maxAutoplays: number;
    public autoplaySteps: number[];
    public defaultAutoplayStep: number;

    public lossLimit: number;
    public singleWinLimit: number;
    public totalWinLimit: number;

    public stopOnFeatureWin: boolean;
    public stopOnAnyWin: boolean;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/betbar/vo/autoplay-options.ts